<template>
  <div>
    <div id="map"></div>
    <div id="mapList" class="table-responsive" v-if="showList">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ $t('map.view.tbl_head_name') }}</th>
            <th scope="col">{{ $t('map.view.tbl_head_street') }}</th>
            <th scope="col">{{ $t('map.view.tbl_head_distance') }}</th>
            <th scope="col">{{ $t('map.view.tbl_head_city') }}</th>
            <!--<th scope="col">{{ $t('map.view.tbl_head_latlng') }}</th>-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(l,i) in locations" :key="l.street" :id="'map-hover-helper-'+i">
            <td scope="row">{{ l.name }}</td>
            <td>{{ l.street }}</td>
            <td>{{ l.distance }}</td>
            <td>{{ l.city }}</td>
            <!--<td>{{l.lat}} / {{l.lng}}</td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiCampaignLocations, } from "@/api/campaigns.js";

import mapsInit from "@/api/maps.js";
import { mapGetters } from "vuex";

export default {
  name: 'CampaignMap',
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    })
  },
  data() {
    return {
      googleApiKey: this.$parent.googleApiKey,
      lat: this.$parent.locLat,
      lng: this.$parent.locLng,
      quality: this.$parent.locQuality,
      campaign: this.$parent.campaignIdent,
      showList: this.$parent.showList,
      distance: 10000,
      google: null,
      gmap: null,
      ggeocoder: null,
      ginfowindow: null,
      locations: [],
      markers: []
    };
  },
  async mounted() {
    try {
      this.google = await mapsInit(this.googleApiKey);
    } catch (error) {
      throw new Error(error);
    }
    switch (this.quality) {
      case "USER":
      case "NAVIGATOR": {
        break;
      }
      case "GEOIP":
      case "FALLBACK":
      default: {
        let old_loc = {
          lat: this.lat,
          lng: this.lat,
          quality: this.quality
        };
        try {
          this.navGeoLoc();
        } catch (error) {
          console.warn(error);
          this.lat = old_loc.lat;
          this.lng = old_loc.lng;
          this.quality = old_loc.quality;
        }
        break;
      }
    }
    await this.fetchData();
    await this.renderMaps();
    this.setLocationMarker();
  },
  methods: {
    async fetchData() {
      this.locations = [];
      const rv = await apiCampaignLocations(this.$userClient, this.campaign, {
        lat: this.lat,
        lng: this.lng
      });
      if (rv) {
        rv.locations.forEach((l,i) => {
          this.locations.push({
            name: l.name || "",
            city: l.city,
            distance: l.distance,
            lat: parseFloat(l.lat),
            lng: parseFloat(l.lng),
            street: l.street
          });
        });
      }
    },
    async renderMaps() {
      this.gmap = new this.google.maps.Map(
        document.getElementById('map'),
        {
          maxZoom: 16,
          minZoom: 10,
          zoom : 12, // initial zoomLevel (less is zoom-out)
          center: { lat: this.locations[0].lat, lng: this.locations[0].lng }
        });

      this.infowindow = new this.google.maps.InfoWindow();

      // --- event-listeners for map --- //
      const that = this;
      this.gmap.addListener('idle', async function() {
        let currentCenter = that.gmap.getCenter();
        let currentZoom = that.gmap.getZoom();
        that.lat = currentCenter.lat();
        that.lng = currentCenter.lng();
        that.distance = 10000 * Math.pow(2,12-that.gmap.getZoom());
        await that.fetchData();
        await that.setLocationMarker();
      });
    },
    setLocationMarker() {
      this.deleteMarkers();
      this.locations.forEach((l,i) => {
        const marker = new this.google.maps.Marker({
          map: this.gmap,
          position: {lat:l.lat,lng:l.lng},
          title: l.street + ", " + l.city,
        });
        const vm = this;

        marker.addListener('click', function() {
          vm.infowindow.setContent('<div>' +
            '<h5>' + l.name + '</h5>' +
            '<div><p><ul>' +
            '<li>' + vm.$t('map.view.tbl_head_street') + ': ' + l.street + '</li>' +
            '<li>' + vm.$t('map.view.tbl_head_city') + ': ' + l.city + '</li>' +
            '<li>' + vm.$t('map.view.tbl_head_distance') + ': ' + l.distance + '</li>' +
            '</ul></p></div>');
          vm.infowindow.open(map, marker);
        });
        let elId = "map-hover-helper-"+i;
        this.google.maps.event.addDomListener(
          document.getElementById(elId),
          'mouseover',
          function() {
            marker.setAnimation(vm.google.maps.Animation.BOUNCE);
          }
        );
        this.google.maps.event.addDomListener(
          document.getElementById(elId),
          'mouseout',
            function() {
              marker.setAnimation(null);
            }
          );
        this.markers.push(marker);
      });
    },
    setMapOnAll(map) {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(map);
      }
    },
    clearMarkers() {
      this.setMapOnAll(null);
    },
    deleteMarkers() {
      this.clearMarkers();
      this.markers = [];
    },
    navGeoLoc() {
      navigator.geolocation.getCurrentPosition(
        this.callbackPosition,
        this.errCallbackPosition,
        {
          timeout: 5000,
          maximumAge: 0,
          enableHighAccuracy: true,
        }
      );
    },
    async callbackPosition (Position) {
      this.lat = Position.coords.latitude;
      this.lng = Position.coords.longitude;
      this.quality = "NAVIGATOR";
      await this.$frontendClient({
        url: "set-location",
        method: "post",
        params: {
          lat: this.lat,
          lng: this.lng,
          quality: this.quality,
        }
      });
    },
    errCallbackPosition (error) {
      console.warn("Could not get Location via native API\n"+error);
      // ev. geoip?
    }
  }
}
</script>

<style scoped>
#map {
  margin: 1rem auto;
  width: 100%;
  height: 50vh;
}
#mapList{
    margin-bottom: 1rem;
}
</style>
